import { advertiserFieldMessage } from '@app/modules/audit/modules/station-audit/components/AdvertiserField';
import { campaignFieldMessage } from '@app/modules/audit/modules/station-audit/components/CampaignField';
import { orderFieldMessage } from '@app/modules/audit/modules/station-audit/components/OrderField';
import { versionFieldMessage } from '@app/modules/audit/modules/station-audit/components/VersionField';
import { ScheduleStatusReportItem } from '@mi-front/core';
import { Box, Stack, Typography } from '@mui/material';
import { MessageDescriptor, useIntl } from 'react-intl';
import { uniqueScheduleField } from './schedule-status-spot-utils';

interface ScheduleStatusSpotDetailMetadataProps {
  item: ScheduleStatusReportItem;
}

/**
 * Advertiser, campaign, order, and version from the grouped schedules.
 */
export function ScheduleStatusSpotDetailMetadata({ item }: ScheduleStatusSpotDetailMetadataProps) {
  const { $t } = useIntl();
  const fields: { label: MessageDescriptor; value: string }[] = [
    { label: advertiserFieldMessage, value: uniqueScheduleField(item.schedules, 'advertiser') },
    { label: campaignFieldMessage, value: uniqueScheduleField(item.schedules, 'campaign') },
    { label: orderFieldMessage, value: uniqueScheduleField(item.schedules, 'order') },
    { label: versionFieldMessage, value: uniqueScheduleField(item.schedules, 'version') },
  ].filter((field) => field.value !== '');

  if (fields.length === 0) {
    return null;
  }

  return (
    <Stack direction="row" flexWrap="wrap" useFlexGap spacing={4}>
      {fields.map((field) => (
        <Box key={field.label.id}>
          <Typography variant="caption" color="text.secondary" display="block">
            {$t(field.label)}
          </Typography>
          <Typography variant="body2">{field.value}</Typography>
        </Box>
      ))}
    </Stack>
  );
}
